import store from "@/store/index";

const ColorUtils = {
    getName(hex) {
        let i = store.state.config.settings.paper_colors.indexOf(hex);
        if (i < 0) {
            return null;
        }
        return store.state.config.settings.paper_color_names[i];
    },
};

export default ColorUtils;
